import React, { useEffect } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {
  Logo,
  NavRight,
  Button,
  LogoImage,
} from './styles.js'
import EarthSvg from '../Icons/EarthSvg'
import { DropMenu, Icon } from '@roo/roo'
import { updateLanguage } from '@/common/utils/i18n'
import Container from '../Container'
import styles from './index.module.less'
import JumpSvg from '../Icons/JumpSvg'
import MenuSvg from '../Icons/MenuSvg'
import ClickDropdownMenu from '../DropdownMenu/index'

const Header = () => {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const handleLanguageChange = (item) => {
    updateLanguage(item.value)
    i18n.changeLanguage(item.value)
  }
  const languageOptions = [
    { value: 'zh-HK', label: '中文繁體' },
    { value: 'en', label: 'English' },
  ]
  const currentLang = i18n.language

  const langLabel = languageOptions.find(item => item.value === currentLang)?.label || 'English'
  const menuOptions = [
    {
      label: t('ent_o_nav_cooperation_cases', '合作案例'),
      value: '/#cooperationCases',
    },
    {
      label: t('ent_o_nav_information', '资讯中心'),
      value: '/information',
    },
    {
      label: t('ent_o_nav_faq', '常见问题'),
      value: '/question',
    },
  ]

  const handleMenuClick = (item) => {
    const  to = item.value
    navigate(to)
  }

  useEffect(() => {
    if (location.hash !== '#cooperationCases') {
      // 滚动到页面顶部
      window.scrollTo({
        top: 0,
      })
    }
  }, [location.pathname])


  return (
    <div className={styles.header}>
      <Container style={{ height: '12rem', padding: '0', display: 'flex', alignItems: 'center', width: '100%' }} >
        <div className={styles.headerContent}>
          <Logo>
            <LogoImage
              onClick={() => {
                if (location.pathname === '/') {
                  window.location.reload() // 刷新当前页面
                  return
                }
                navigate('/')
              }}
              src={'https://img-ap-hongkong.mykeeta.net/sailorcweb/ecf9047de6504294fc49edafba1116c419854.png'}  />
          </Logo>
          <div className={styles.nav}>
            {menuOptions.map((item) => <SmartLink to={item.value} >{item.label}</SmartLink>)}
          </div>
          <NavRight>
            <ClickDropdownMenu menu={languageOptions} onItemClick={handleLanguageChange} >
              <Button style={{ paddingLeft: '0', paddingRight: '0' }} >
                <EarthSvg size={'20'} fill="#000000"/>
                <span style={{ color: '#000000' }}>&nbsp;{langLabel}&nbsp;</span>
                <Icon name="chevron-down" size={20} color="#000000"/>
              </Button>
            </ClickDropdownMenu>
            {
              !location.pathname?.includes('contact') && (
                <div className={styles.contactWraper}>
                  <Button as={Link} to="/contact" variant="secondary">
                    {t('ent_o_nav_contact')}
                  </Button>
                </div>
              )
            }
            <div className={styles.mobileMenu}>
              <ClickDropdownMenu
                menu={[{ label: t('ent_o_nav_contact'), value: '/contact' }, ...menuOptions]}
                onItemClick={handleMenuClick}
              >
                <MenuSvg width="16" height="16"/>
              </ClickDropdownMenu>
            </div>
          </NavRight>
        </div>
      </Container>
    </div>
  )
}

const SmartLink = ({ to = '', children }) => {
  const location = useLocation()
  const isCurrentPageLink =  to.split('#')[0] === location.pathname
  return (
    <Link
      to={to}
      className={styles.contactItem}
      target={isCurrentPageLink ? undefined : '_blank'}
    >
      {children}
      {!isCurrentPageLink && <JumpSvg />}
    </Link>
  )
}


export default Header